// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase:{
    apiKey: "AIzaSyB0QGoENcYB3kQge_TYEwi7CrVF66JHY-0",
    authDomain: "roshani-solar-dc171.firebaseapp.com",
    databaseURL: "https://roshani-solar-dc171.firebaseio.com",
    projectId: "roshani-solar-dc171",
    storageBucket: "roshani-solar-dc171.appspot.com",
    messagingSenderId: "36206336483",
    appId: "1:36206336483:web:aaea1b8b0a152d242168d6"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
